module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('img', {
    attrs: {
      "src": _vm.bgNav
    }
  }), _vm._v(" "), _c('el-menu', {
    attrs: {
      "unique-opened": true,
      "router": "",
      "default-active": _vm.defaultSelect
    }
  }, [_vm._l((_vm.menu), function(item, key) {
    return [(item.child) ? [_c('el-submenu', {
      attrs: {
        "index": key
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('el-menu-item-group', [_vm._l((item.child), function(i, k) {
      return [_c('el-menu-item', {
        attrs: {
          "index": k
        }
      }, [(i.icon) ? _c('i', {
        class: i.icon
      }) : _vm._e(), _vm._v(_vm._s(i.name))])]
    })], 2)], 2)] : [_c('el-menu-item', {
      attrs: {
        "index": key
      }
    }, [_vm._v(_vm._s(item.name))])]]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-914a0340"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/nav-menu.vue
// module id = 789
// module chunks = 1